import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 11.5,
			transform: "rotate(-180 12 12)",
			stroke: "#FE4A4A"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11.9375,
			y1: 14.375,
			x2: 11.9375,
			y2: 5.375,
			stroke: "#FE4A4A"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 18,
			r: .5,
			transform: "rotate(-180 12 18)",
			stroke: "#FE4A4A"
		})
	]
});
export default SvgError;
